import { PropsWithChildren } from 'react';
import classNames from 'classnames';

interface DrawerFooterProps extends PropsWithChildren {
    insideTab?: boolean;
}

export const DrawerFooter = ({
    insideTab = false,
    children,
}: DrawerFooterProps) => (
    <footer
        className={classNames(
            'mt-auto border-t border-gray-200 gap-2 [&>button]:w-full flex flex-col justify-between drawer-lg:flex-row-reverse drawer-lg:[&>button]:w-auto px-4 drawer-lg:px-6',
            {
                ['py-4 drawer-lg:py-6']: !insideTab,
                ['pb-0 pt-4 drawer-lg:pt-6']: insideTab,
            }
        )}
    >
        {children}
    </footer>
);
